import store from '@/renderer/store';
import { i18n_t } from '@/locales/i18n';
import { phoneCompose } from '@/renderer/scripts/utils/tools/index';

// 展示手机号或账号
export function showPhoneOrAccountName({ accountName = '', countryCode = '', phoneNumber = '', inactive = false }) {
  let showInfo = '';
  if (store.getters.onlyPasswordLogin) {
    showInfo = accountName || i18n_t('未设置账号');
  } else {
    showInfo = phoneCompose(countryCode, phoneNumber, inactive);
  }
  // 交大无手机号情况下不显示暂未绑定 不加括号显示
  return showInfo ? `（${showInfo}）` : '';
}
